export const TYPE_TENDER_JSON = [
  {
    text: "预告",
    id: 1,
    tip: "招标公告正式发布前，大部分采购人会提前3-7天公布招标预告",
    children: [
      {
        text: "意见征集",
        id: 1001,
      },
      {
        text: "招标预告",
        id: 1002,
      },
    ],
  },
  {
    text: "公告",
    id: 0,
    tip: "采购人针对采购需求发布的公告，包含采购标准和条件等项目内容变更：采购人对于已发布公告信息进行澄清或者修改的变更通知公告",
    children: [
      {
        text: "招标公告",
        id: 1003,
      },
      {
        text: "重新招标",
        id: 1004,
      },
    ],
  },
  {
    text: "采购意向",
    id: 99,
    tip: "招标公告正式发布前，大部分采购人会提前至少30天公布采购意向（该提醒使用问号交互提醒）",
    children: [],
  },
  {
    text: "变更",
    id: 2,
    children: [
      {
        text: "信息变更",
        id: 1005,
      },
      {
        text: "答疑公告",
        id: 1006,
      },
    ],
  },

  {
    text: "国土",
    id: 4,
    children: [],
  },

  {
    text: "其他",
    id: 5,
    children: [
      {
        text: "违规公告",
        id: 1014,
      },
      {
        text: "其他公告",
        id: 1015,
      },
    ],
  },
];

export const TYPE_WINBIDDING_JSON = [
  {
    text: "中标",
    id: 3,
    children: [
      {
        text: "中标通知",
        pid: 3,
        id: 1011,
      },
      {
        text: "合同公告",
        pid: 3,
        id: 1012,
      },
      {
        text: "候选人公示",
        pid: 3,
        id: 1010,
      },
      {
        text: "开标公示",
        pid: 3,
        id: 1009,
      },
      {
        text: "流标公告",
        pid: 3,
        id: 1008,
      },
      {
        text: "废标公告",
        pid: 3,
        id: 1007,
      },
    ],
  },
  {
    text: "国土",
    id: 4,
    children: [
      {
        text: "国土",
        pid: 4,
        id: 999,
      },
    ],
  },
  {
    text: "其他",
    id: 5,
    children: [
      {
        text: "其他",
        pid: 5,
        id: 1013,
      },
    ],
  },
];

export const TYPE_BIDDING_INFO_JSON = [
  {
    text: "采购意向",
    id: 99,
    popover: true,
    tip: "招标公告正式发布前，大部分采购人会提前至少30天公布采购意向",
    children: [],
  },
  {
    text: "预告",
    id: 1,
    tip: "招标公告正式发布前，大部分采购人会提前3-7天公布招标预告",
    children: [
      {
        text: "意见征集",
        id: 1001,
        tip: "当采购人需征求相关供应商、专家意见，来完善采购需求时发布的公告信息，单一来源采购之前也需发布意见征集",
      },
      {
        text: "招标预告",
        id: 1002,
        tip: "招标公告正式发布前，大部分招标单位会提前3-7天公布招标预告",
      },
    ],
  },
  {
    text: "公告",
    id: 0,
    tip: "采购人针对采购需求发布的公告，包含采购标准和条件等项目内容",
    children: [
      {
        text: "招标公告",
        id: 1003,
        tip: "采购人针对采购需求发布的公告，包含采购标准和条件等项目内容",
      },
      {
        text: "重新招标",
        id: 1004,
        tip: "采购人对招标项目招标失败后依法对招标项目进行重新招标的公告",
      },
    ],
  },
  {
    text: "变更",
    id: 2,
    tip: "采购人对于已发布公告信息进行澄清或者修改的变更通知公告",
    children: [
      {
        text: "信息变更",
        id: 1005,
        tip: "采购人对于已发布公告信息进行澄清或者修改的变更公告",
      },
      {
        text: "答疑公告",
        id: 1006,
        tip: "采购人对于采购活动事项疑问做出的答复公告",
      },
    ],
  },
  {
    text: "结果",
    id: 3,
    tip: "采购人发布的招标结果公告，包含候选人公示、中标通知、废标公告等多种类型",
    children: [
      {
        text: "开标公示",
        id: 1009,
        tip: "投标截止时，由采购人主持并邀请所有投标人参加，宣读投标人、投标价格等信息的记录",
      },
      {
        text: "候选人公示",
        id: 1010,
        tip: "评标委员会对投标文件进行评审和比较后，公布的评标报告和推荐的合格中标候选人",
      },
      {
        text: "中标通知",
        id: 1011,
        tip: "确定中标人后，采购人发出的中标通知书",
      },
      {
        text: "合同公告",
        id: 1012,
        tip: "在中标后，采购人与供应商按招标文件内容签订的采购合同",
      },
      {
        text: "流标公告",
        id: 1008,
        tip: "因响应的供应商不足3家等异常问题，导致采购取消的公告",
      },
      {
        text: "废标公告",
        id: 1007,
        tip: "因采购违规、超出采购预算或其他重大变故，导致采购任务取消的公告",
      },
    ],
  },
  {
    text: "其他",
    id: 5,
    children: [
      {
        text: "验收公告",
        id: 1013,
        tip: "采购人对供应商履约的验收，并公布的验收结果公告",
      },
      {
        text: "违规公告",
        id: 1014,
        tip: "对招投标活动当事人的招投标活动违法行为记录的公告",
      },
      {
        text: "其他公告",
        id: 1015,
        tip: "",
      },
    ],
  },
  {
    text: "国土",
    id: 4,
    tip: "国土资源交易公示信息",
    children: [],
  },
];
